import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointTablet,
  BreakPointMobile,
  BreakPointDesktop,
} from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    margin: `${theme.spacing.space20}px 0`,
    marginBottom: theme.spacing.space48,
    [BreakPointTablet]: {
      margin: `${theme.spacing.space12}px 0`,
    },
    [BreakPointMobile]: {
      margin: `${theme.spacing.space8}px 0`,
    },
  },
  content: {
    width: "100%",
    boxSizing: "border-box",
    pointerEvents: "auto",
    position: "relative",
    overflow: "hidden",
    flexShrink: 0,
    aspectRatio: 2 / 1,
    "&.isDesktop": {
      display: "flex",
    },
    [BreakPointDesktop]: {
      aspectRatio: 3840 / 1320,
    },
  },
  image: {
    display: "block",
    width: "100%",
    height: "auto",
    zIndex: 0,
    [BreakPointMobile]: {
      "@media (orientation: portrait)": {
        height: "100%",
        objectFit: "cover",
      },
    },
  },
  disclaimerText: {
    padding: "0px 6.5vw",
    "&.isDesktop": {
      position: "absolute",
      bottom: 0,
    },
    [BreakPointTablet]: {
      padding: `${theme.spacing.space8}px ${theme.spacing.space16}px 0`,
      fontSize: "9px !important",
      fontWeight: "400 !important",
    },
    [BreakPointMobile]: {
      padding: `${theme.spacing.space8}px ${theme.spacing.space16}px 0`,
      fontSize: "9px !important",
      fontWeight: "400 !important",
    },
  },
}));
